import { IQuestionModel } from '../../state/stores/Question/QuestionModel';
import { Maybe } from 'graphql/jsutils/Maybe';
import { SnapshotOut } from 'mobx-state-tree';
import { useStores } from '../useStores';

/**
 * Interpolates values into question.description and question.question based
 * on previous answers to the current survey.
 * For example: '{{companyRegion}}' will be replaced by the answer to the question
 * with the key 'phoneCompanyRegionsCheck'.
 */
// this can be made more general
// for example, replacement key based on the question.key and answer.key
// like this: text.replace(${question.key}.${answer.key}, ${response.value})
// which means, in the admin page, we can reliably change the text using previous values
// without changing any code
// and using a collection of key-value pairs
// we can provide another similar hook for answer.wording
export const useReferentialQuestionContent = (question: SnapshotOut<IQuestionModel>) => {
  const { treeNav } = useStores();

  const companyRegion = treeNav.choices.finalised
    ?.find(response => response.questionKey === 'phoneCompanyRegionsCheck')
    ?.answers[0]?.key;

  const interpolator = (text: Maybe<string>, key: string, value: Maybe<string>) => {
    return value
      ? text?.replace(new RegExp(`{{${key}}}`, 'g'), value)
      : text;
  };

  return {
    description: interpolator(question.description, 'companyRegion', companyRegion),
    question: interpolator(question.question, 'companyRegion', companyRegion),
  };
};
